import React, { Fragment } from "react";
import BTable from "react-bootstrap/Table";
import Spinner from "react-bootstrap/Spinner";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
// import Button from "react-bootstrap/Button";
import { GrDownload } from "react-icons/gr";
import { CSVLink } from "react-csv";
import {  useTable,useFilters } from "react-table";
import matchSorter from 'match-sorter';
import TableStyle from "./table.module.css";
import { IconContext } from "react-icons/lib";
import {AiOutlineSearch} from "react-icons/ai";
// Define a default UI for filtering

function DefaultColumnFilter({
  column: { filterValue, preFilteredRows, setFilter },
}) {
  const count = preFilteredRows.length

  return (
      <div className={TableStyle.oneRow}>
    <input
      value={filterValue || ''}
      onChange={e => {
        setFilter(e.target.value || undefined) // Set undefined to remove the filter entirely
      }}
      placeholder={`${count} countries`  }
      size={15}
    />
    <IconContext.Provider value={{ size: "1.5em",className: TableStyle.infoIcon}}><AiOutlineSearch/></IconContext.Provider>
    </div>
  )
}
// This is a custom filter UI for selecting
// a unique option from a list
// function SelectColumnFilter({
//   column: { filterValue, setFilter, preFilteredRows, id },
// }) {
//   // Calculate the options for filtering
//   // using the preFilteredRows
//   const options = React.useMemo(() => {
//     const options = new Set()
//     preFilteredRows.forEach(row => {
//       options.add(row.values[id])
//     })
//     return [...options.values()]
//   }, [id, preFilteredRows])

//   // Render a multi-select box
//   return (
//     <select
//       value={filterValue}
//       onChange={e => {
//         setFilter(e.target.value || undefined)
//       }}
//     >
//       <option value="">All</option>
//       {options.map((option, i) => (
//         <option key={i} value={option}>
//           {option}
//         </option>
//       ))}
//     </select>
//   )
// }

function fuzzyTextFilterFn(rows, id, filterValue) {
  return matchSorter(rows, filterValue, { keys: [row => row.values[id]] })
}

// Let the table remove the filter if the string is empty
fuzzyTextFilterFn.autoRemove = val => !val

function Table({
  isLoading,
  columns,
  data,
  downloadFileName,
  mouseLeave = () => () => { },
  mouseEnter = () => () => { },
  dataTipField = "",
  icon,
  iconCol = "",
  disclaimer = "",
}) {
  const csvHeader = columns.map((val) => {
    const header = {};
    header.label = val.Header;
    header.key = val.accessor;
    return header;
  });

  const filterTypes = React.useMemo(
    () => ({
      // Add a new fuzzyTextFilterFn filter type.
      fuzzyText: fuzzyTextFilterFn,
      // Or, override the default text filter to use
      // "startWith"
      text: (rows, id, filterValue) => {
        return rows.filter(row => {
          const rowValue = row.values[id]
          return rowValue !== undefined
            ? String(rowValue)
                .toLowerCase()
                .startsWith(String(filterValue).toLowerCase())
            : true
        })
      },
    }),
    []
  )

  const defaultColumn = React.useMemo(
    () => ({
      // Let's set up our default Filter UI
      Filter: DefaultColumnFilter,
    }),
    []
  )

  // Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    // page,

    //pagination stuff
    // canPreviousPage,
    // canNextPage,
    // pageOptions,
    // pageCount,
    // gotoPage,
    // nextPage,
    // previousPage,
    // setPageSize,
    // state: { pageIndex, pageSize },
    // state: { pageIndex },
  } = useTable(
    {
      columns,
      data,
      defaultColumn,
    filterTypes,
      autoResetPage: false,
      // initialState: { pageIndex: 0, pageSize: 10 },
    },
    useFilters
    // usePagination
  );

  // Render the UI for your table
  return (
    <div>
      <div className={TableStyle.tableWrap}>
        {isLoading ? (
          <div className={TableStyle.spinnerContainer}>
            <Spinner animation="border" />
          </div>
        ) : (
          <BTable striped bordered hover size="sm" {...getTableProps()}>
            <thead>
              {headerGroups.map((headerGroup) => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map((column) => (
                    <th {...column.getHeaderProps(column.Header === "Country" ?{ width:'130px'}:'')} >
                      {column.render("Header")}
                      <div>{column.Header === "Country" ? column.render('Filter') : null}</div>
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps()}>
              {rows.map((row, i) => {
                prepareRow(row);
                return (
                  <tr {...row.getRowProps()} key={i}>
                    {row.cells.map((cell) => {
                      return cell.column.Header === iconCol ? (
                        <td
                          {...cell.getCellProps()}
                          className={TableStyle.iconRow}
                        >
                          <span>{cell.value}</span>
                          <span
                            onMouseEnter={mouseEnter({ rowData: row.original })}
                            onMouseLeave={mouseLeave({ rowData: row.original })}
                            data-tip={row.original[dataTipField] ?? ""}
                          >
                            <IconContext.Provider value={{ size: "1.25em",className: TableStyle.infoIcon}}>{icon}</IconContext.Provider>
                          </span>
                        </td>
                      ) : (
                        <td {...cell.getCellProps()} style={{ whiteSpace: "nowrap" }}>{cell.render("Cell")}</td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </BTable>
        )}

      </div>
      {disclaimer === "" ? null : (
        <div className={`${TableStyle.disclaimer} mt-2`}>{disclaimer}</div>
      )}
      {(
        <div style={{ display: "block" }}>
          <Row className={TableStyle.paginationControl}>
            {/* <Col sm={12} md={6}> */}
              {/* <Button
              variant="light"
              size="sm"
              onClick={() => gotoPage(0)}
              disabled={!canPreviousPage}
            >
              {"<<"}
            </Button>
            <Button
              variant="light"
              size="sm"
              onClick={() => previousPage()}
              disabled={!canPreviousPage}
            >
              {"<"}
            </Button>
            <Button
              variant="light"
              size="sm"
              onClick={() => nextPage()}
              disabled={!canNextPage}
            >
              {">"}
            </Button>
            <Button
              variant="light"
              size="sm"
              onClick={() => gotoPage(pageCount - 1)}
              disabled={!canNextPage}
            >
              {">>"}
            </Button>
            <p>
              {" "}
              Page <strong>{pageIndex + 1} </strong> of{" "}
              <strong>{pageOptions.length}</strong>
            </p> */}
            {/* </Col> */}
            <Col xs={12} md={12} >
              <CSVLink
                data={data}
                title="Download Table"
                headers={csvHeader}
                filename={downloadFileName}
                className="btn tn-sm"
                style={{ textDecoration: "none", borderRadius:"3px" }}
                target="_blank"
              >
                <GrDownload />
              </CSVLink>
            </Col>
          </Row>
        </div>
      )}
    </div>
  );
}

export default Table;
